import axios from "axios";

function getCardDesignInfo(client_access_key, bearerToken) {
  return axios
    .get("https://data.yimbatech.com/card-designs", {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + bearerToken,
        "x-client-access-token": `${client_access_key}`,
      },
    })
    .then(response => response.data);
}

export default getCardDesignInfo;
